import { formatDateToYYYYMMDD } from "Common/HelperClass";
import { HotSellerPeriodType } from "../../Types";

export const formatDateForDisplay = (date: Date | null): string => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const calculateDateRange = (period: HotSellerPeriodType): { startDate: string; endDate: string } => {
    if (period === 'All') {
        return { startDate: '', endDate: '' };
    }

    if (period === 'Custom Date') {
        return { startDate: '', endDate: '' };
    }

    const today = new Date();
    const endDate = formatDateToYYYYMMDD(today);
    const startDateObj = new Date();

    const monthsToSubtract = {
        'Last 3 Months': 3,
        'Last 6 Months': 6,
        'Last 9 Months': 9,
        'Last 12 Months': 12
    }[period] || 0;

    startDateObj.setMonth(today.getMonth() - monthsToSubtract);
    return {
        startDate: formatDateToYYYYMMDD(startDateObj),
        endDate
    };
};

export const parseDate = (dateStr: string | undefined): Date | null => {
    try {
        if (!dateStr || dateStr.trim() === "") return null;
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? null : date;
    } catch (e) {
        console.error("Error parsing date:", e);
        return null;
    }
};